import { PublicKey } from '@solana/web3.js';
import { getSolanaConnection } from '../connection';
import { decodeVaultState } from '../decoders/vaultState';

const EMPTY_PUBLIC_KEY = PublicKey.default.toBase58();

function normalizeReserveVaultPubkey(value) {
  if (!value || value === EMPTY_PUBLIC_KEY) {
    return '';
  }

  return value;
}

export function subscribeToCurrentReserveVault(reserveVaultPubkey, onUpdate, onError) {
  const connection = getSolanaConnection();
  const normalizedReserveVaultPubkey = normalizeReserveVaultPubkey(reserveVaultPubkey);

  if (!normalizedReserveVaultPubkey) {
    return () => {};
  }

  const publicKey = new PublicKey(normalizedReserveVaultPubkey);
  const subscriptionId = connection.onAccountChange(
    publicKey,
    (accountInfo) => {
      try {
        onUpdate({
          publicKey: normalizedReserveVaultPubkey,
          lamports: accountInfo.lamports,
          data: decodeVaultState(accountInfo.data),
          updatedAt: Date.now(),
        });
      } catch (error) {
        onError?.(error);
      }
    },
    'confirmed'
  );

  return () => connection.removeAccountChangeListener(subscriptionId);
}
